<template>
  <div class="add-clean-task-modal">
    <el-form
      :rules="rules"
      :model="formData"
      inline
      label-position="top"
      ref="formRef"
    >
      <el-form-item label="状态：" class="w-p-100" prop="status">
        <el-radio-group v-model="formData.status" :disabled="cleanTaskId">
          <el-radio :label="1">未开始</el-radio>
          <el-radio :label="2">保洁中</el-radio>
          <el-radio :label="3">已打扫</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="roomId" label="房源">
        <el-select v-model="formData.roomId" :disabled="cleanTaskId">
          <el-option
            v-for="item in roomList"
            :key="item.id"
            :value="item.id"
            :label="item.roomName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-row>
        <el-col :span="6">
          <el-form-item label="日期" prop="taskStartTime">
            <el-date-picker
              :disabled="cleanTaskId"
              :editable="false"
              :clearable="false"
              v-model="taskDate"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="时段" prop="taskEndTime">
            <el-time-picker
              :editable="false"
              v-model="taskTimeRange"
              is-range
              format="HH:mm"
              value-format="HH:mm:ss"
              range-separator="-"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="保洁员" prop="staffId">
            <el-select v-model="formData.staffId">
              <el-option
                v-for="item in cleanerList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
            <el-button class="m-l-5 border-btn primary" @click="addCleaner"
              >添加</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="类型" prop="type">
        <el-select v-model="formData.type">
          <el-option :value="1" label="简单"></el-option>
          <el-option :value="2" label="标准"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="费用">
        <el-input
          placeholder="请输入"
          class="w-200"
          v-model.trim="formData.price"
        ></el-input>
        <!-- <el-button class="m-l-5 border-btn warn">价格设置</el-button> -->
      </el-form-item>
      <el-form-item label="备注" class="w-p-100">
        <el-input type="textarea" v-model.trim="formData.remark"></el-input>
      </el-form-item>
    </el-form>
    <div class="align-c m-t-20 p-t-10">
      <el-button class="submit-btn" @click="handleSave">确定</el-button>
      <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
    </div>
  </div>
  <RModal
    title="新增保洁人员"
    v-model="addCleanerModalShow"
    :closeOnClick="false"
    @change="addCleanerModalShow = false"
  >
    <template v-slot:content>
      <add-cleaner-modal
        v-if="addCleanerModalShow"
        :storeId="storeId"
        @close="closeModal"
      ></add-cleaner-modal>
    </template>
  </RModal>
</template>

<script>
import { mapActions } from "vuex";
import Moment from 'moment'
import RModal from '@/components/common/RModal'
import addCleanerModal from '../cleanerManage/addCleanerModal'

export default {
  components: { RModal, addCleanerModal },
  emits: ['close'],
  props: {
    cleanTaskId: {},
    storeId: {},
    roomList: {
      type: Array,
      required: true,
      default: []
    },

  },
  data() {
    const date = Moment(new Date()).format('YYYY-MM-DD');
    let curHour = Moment(new Date()).format('HH')*1;

    let taskTimeRange = ['12:00:00', '14:00:00']
    if(curHour==23){
      taskTimeRange = ['23:00:00', '23:59:00']
    }if(curHour>=21){
      taskTimeRange = [(curHour+1)+':00:00','23:59:00']
    }else if(curHour>=12){
      taskTimeRange = [(curHour+1)+':00:00',(curHour+3)+':00:00']
    }

    return {
      taskDate: date,
      taskTimeRange: taskTimeRange,
      addCleanerModalShow: false,
      cleanerList: [],
      formData: {
        status: 1,
        roomId: null,
        taskStartTime: '',
        taskEndTime: '',
        staffId: null,
        type: 1,
        price: '',
        remark: '',
        storeId: this.storeId
      },
      rules: {
        status: [{ required: true }],
        roomId: [{ required: true, message: '请选择房源', trigger: 'change' }],
        staffId: [{ required: true, message: '请选择保洁员', trigger: 'change' }],
        taskStartTime: [{
          required: true, validator: (rule, value, callback) => {
            if (!this.taskDate) {
              callback(new Error('请设置任务执行日期'))
            } else {
              callback()
            }
          }, trigger: 'change'
        }],
        taskEndTime: [{
          required: true, validator: (rule, value, callback) => {
            if (!this.taskTimeRange) {
              callback(new Error('请设置任务执行时段'))
            } else {
              callback()
            }
          }, trigger: 'change'
        }],
        type: [{ required: true }]
      }
    }
  },

  created() {
    this.getCleanerList();
    if (this.cleanTaskId) {
      this.getDetail();
    }
  },

  methods: {
    ...mapActions(["fetchData"]),

    // 获取保洁人员列表
    getCleanerList() {
      let url = 'CLEAN.CLEANER.GET_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: { storeId: this.storeId, pageSize: 9999, pageNumber: 1, status: 1 }
      }).then(res => {
        this.cleanerList = res?.data || []
      })
    },

    // 详情
    getDetail() {
      this.fetchData({
        url: 'CLEAN.TASK.GET_DETAIL',
        method: 'get',
        params: { id: this.cleanTaskId }
      }).then(res => {
        if (res) {
          this.formData = res;
          this.taskDate = res['taskStartTime'].split(' ')[0]
          this.taskTimeRange = [res['taskStartTime'].split(' ')[1], res['taskEndTime'].split(' ')[1]]
        } else {
          this.$message.error('数据获取失败')
        }
      }).catch(err => {
        this.$message.error('数据获取失败')
      })
    },

    // 添加保洁人员
    addCleaner() {
      this.addCleanerModalShow = true;
    },

    // 提交
    handleSave() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.formData.taskStartTime = this.taskDate + ' ' + this.taskTimeRange[0];
          this.formData.taskEndTime = this.taskDate + ' ' + this.taskTimeRange[1];
          this.fetchData({
            url: 'CLEAN.TASK.POST_SAVE',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            params: this.formData
          }).then(res => {
            if (res) {
              this.$message.success('操作成功')
              this.handleCancel(true);
            } else {
              this.$message.error('操作失败')
            }
          }).catch(err => {
            this.$message.error('操作失败')
          })
        }
      })
    },

    // 关闭添加保洁人员弹框
    closeModal($event) {
      this.addCleanerModalShow = false;
      if ($event === true) {
        this.getCleanerList();
      }
    },

    // 关闭对话框
    handleCancel(success) {
      this.$emit('close', success)
    }
  }
}
</script>